<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Atualizar conforme JACAD
          </h4>
        </div>
        <div v-if="isBillingWithExternalId && !isPresencialCourse" class="modal-body">
          <p>
            Clique em confirmar para atualizar as mensalidades conforme o JACAD
          </p>
        </div>
        <div v-else-if="isBillingWithExternalId && isPresencialCourse" class="modal-body">
          <p>
            Este curso está na modalidade presencial e não pode ser atualizado conforme Jacad.
          </p>
        </div>
        <div v-else class="modal-body">
          <div class="alert alert-danger">
            <p>
              Cobrança não possui External ID: Entre em contato com o Suporte
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="isBillingWithExternalId"
                  class="btn btn-primary"
                  :disabled="isPresencialCourse"
                  @click="updateFcvBillingWithJacad()"
          >
            Confirmar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillingsService from 'services/BillingsService';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBillingWithExternalId() {
      return this.billing.external_id;
    },
    isPresencialCourse() {
      return this.billing.billing_course.kind === 'Presencial';
    },
  },
  methods: {
    updateFcvBillingWithJacad() {
      this.$loader.show();
      BillingsService.updateFcvBillingWithJacad(this.billing.id)
        .then(() => this.$alert.notifySuccess('Recarregue a página em alguns minutos para ver o painel atualizado.'))
        .catch(({ body }) => this.$alert.notifyAlert(`Erro ao atualizar a cobrança: ${body.message}`))
        .finally(() => {
          this.$emit('close');
          this.$loader.hide();
        });
    },
  },
};
</script>
